import styled from 'styled-components';

const Section = styled.div`
  border-top: ${props => props.theme.borderLt};
  display: flex;
  padding: 32px 0;
  width: 100%;
`;

export default Section;
